// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "container-33pPb";
var _3 = "price-3AHwt";
var _4 = "price__money-2s5zc";
var _5 = "button-1zyvg";
var _6 = "single__time-3GhTG";
var _7 = "single__timeInRoute-34lUL";
var _8 = "single__date-20Wlx";
var _9 = "route__time-N2bbG";
var _a = "single__aircraft-3LEiP";
var _b = "segment__planeInfo-2aCYq";
var _c = "segment__aircraft-2GJPg";
var _d = "pointDate__container--KYpX";
var _e = "point_arrival-3-z3g";
export { _1 as "__esModule", _2 as "container", _3 as "price", _4 as "price__money", _5 as "button", _6 as "single__time", _7 as "single__timeInRoute", _8 as "single__date", _9 as "route__time", _a as "single__aircraft", _b as "segment__planeInfo", _c as "segment__aircraft", _d as "pointDate__container", _e as "point_arrival" }
export default { "__esModule": _1, "container": _2, "price": _3, "price__money": _4, "button": _5, "single__time": _6, "single__timeInRoute": _7, "single__date": _8, "route__time": _9, "single__aircraft": _a, "segment__planeInfo": _b, "segment__aircraft": _c, "pointDate__container": _d, "point_arrival": _e }
